<template>
  <div class="organization-title">
    <OrganizationIcon />
    <span class="name">{{ title || "Loading..." }}</span>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, toRefs } from "vue";

import OrganizationIcon from "@/components/icons/OrganizationIcon.vue";
import * as inject from "@/components/inject";
import { getOrganization } from "@/composables/useProfile";

export default defineComponent({
  name: "OrganizationTitle",
  components: {
    OrganizationIcon,
  },
  props: {
    orgId: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { orgId } = toRefs(props);
    const profile = inject.profile();

    const title = computed(
      () => getOrganization(profile.value, orgId.value)?.name || "Organization"
    );

    return {
      title,
    };
  },
});
</script>

<style lang="scss" scoped>
.organization-title {
  display: flex;
  align-items: center;
  width: 100%;

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
